import type { AuditStatusResponse } from "./types";

const API_BASE = import.meta.env.VITE_API_BASE ?? "";

function apiUrl(path: string): string {
  if (!API_BASE) return path;
  return `${API_BASE.replace(/\/$/, "")}${path}`;
}

export async function startAudit(url: string): Promise<{ id: string; cached: boolean }> {
  const res = await fetch(apiUrl("/api/audit"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ url }),
  });
  if (!res.ok) {
    let message = `Audit start failed (${res.status})`;
    try {
      const data = (await res.json()) as { error?: string };
      if (data.error) message = data.error;
    } catch {
      // ignore
    }
    throw new Error(message);
  }
  return res.json();
}

export async function getAudit(id: string): Promise<AuditStatusResponse> {
  const res = await fetch(apiUrl(`/api/audit/${id}`));
  if (!res.ok) {
    throw new Error(`Audit lookup failed (${res.status})`);
  }
  return res.json();
}
